import { hookupIpc } from './index.js';

hookupIpc();
